import { aanpAuthOptions } from "./util";
import { apiUrl, storageKeys } from "../config";
import Cookies from "js-cookie";
import instance from "./instance";

export function getRegistrationInfo() {
  return instance
    .get(`${apiUrl}/registrationinfo/`, aanpAuthOptions())
    .then((r) => r.data);
}

export function getHpRegistrationInfo() {
    return instance
        .get(`${apiUrl}/registrationinfo/GetHPRegistrationInfo`, aanpAuthOptions())
        .then((r) => r.data);
}

export function saveRegistrationInfo(registrationInfo) {
  return instance
    .post(
      `${apiUrl}/registrationinfo/`,
      { ...registrationInfo },
      aanpAuthOptions()
    )
    .then((r) => r.data);
}

export function saveHpRegistrationInfo(registrationInfo) {
    return instance
        .post(
            `${apiUrl}/registrationInfo/SaveHpRegistrationInfo`,
            { ...registrationInfo },
            aanpAuthOptions()
        )
        .then(r => r.data);
}

export function getJoinRenew(registeringAs) {
  return instance
    .get(
      `${apiUrl}/registrationinfo/getjoinrenew/${registeringAs}`,
      aanpAuthOptions()
    )
    .then((r) => r.data);
}

export function uploadStudentProof(fileData) {
  const formData = new FormData();
  formData.append("body", fileData);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Aanp-Token": Cookies.get(storageKeys.authToken),
    },
  };

  return instance
    .post(`${apiUrl}/registrationinfo/uploadStudentProof`, formData, config)
    .then((r) => r.data);
}
